import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../helper/api";
import { toast } from "react-toastify";

export const adminGameHistory = createAsyncThunk("user/adminGameHistory", async (payload) => {

  const response = await api.post("admin/game-history", payload);
 
  return response.data.data;
});

const adminGameHistorySlice = createSlice({
  name: "user",
  initialState: {
    data:null,
    loading: false,
    error: null,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminGameHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(adminGameHistory.fulfilled, (state, action) => {
        
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(adminGameHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default adminGameHistorySlice.reducer;
